import api from 'common/api';
import {
  SearchAITGroupMasterRequest,
  DetailAITGroupMasterRequest,
  UpdateAITGroupMasterRequest,
  DeleteAITGroupMasterRequest,
} from 'api-types/src/types/ait-group-master';

export const getAitGrAPI = (params: SearchAITGroupMasterRequest) => api.get('/ait-group-master/list', params);

export const getAitGrDetailAPI = (params: DetailAITGroupMasterRequest) => api.get('/ait-group-master/detail', params);

export const addAitGrAPI = (params: UpdateAITGroupMasterRequest) => api.post('/ait-group-master', params);

export const deleteAitGrAPI = (params: DeleteAITGroupMasterRequest) => api.put('/ait-group-master/delete', params);

export const DOWNLOAD_EXCEL_AIT_GR_MAST = '/ait-group-master/list';
